import styled from 'styled-components';

import LoginPhoto from '../../../../assets/hopskipdrive-welcome-v2.png';
import { colorPalette, colorTokens } from '../../../../shared/components/variables';

export const LayoutStyled = styled.div`
  height: 100vh;
  min-height: 950px;
  display: flex;
  flex-direction: column;
  background: ${colorPalette.brandWarmWhite};

  @media (max-width: 1200px) {
    min-height: 921px;
  }
`;

export const HeaderStyled = styled.header`
  padding: 32px 32px 0;

  img {
    display: block;
    width: 184px;
    height: auto;
  }
`;

export const MainStyled = styled.main`
  flex: 1;
  min-height: 0;
  width: 100%;
  max-width: 1814px;
  margin: 50px auto 0;
  padding: 46px 46px 45px;
  display: grid;
  grid-template-columns: minmax(0, 489px) minmax(0, 1fr);
  grid-template-rows: minmax(0, 1fr);
  align-items: center;
  gap: 31px;

  @media (max-width: 1034px) {
    grid-template-columns: minmax(0, 1fr);
  }

  @media (max-width: 480px) {
    padding-right: 20px;
    padding-left: 20px;
  }
`;

export const ContentStyled = styled.div`
  width: 100%;
  max-width: 489px;
  min-width: 0;
  height: 746px;
  padding: 32px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  > :first-child {
    width: 100%;
    max-width: 334px;
  }

  form {
    width: 100%;
    max-width: 100%;
  }

  form .MuiFormControl-root,
  form button {
    max-width: 100%;
  }

  > :last-child {
    max-width: 334px;
    margin-top: 48px;
  }

  @media (max-width: 1034px) {
    max-width: none;
  }
`;

export const FooterStyled = styled.div`
  text-align: center;
  width: 100%;
`;

export const ArtworkStyled = styled.div`
  position: relative;
  width: 100%;
  max-width: 826px;
  max-height: 746px;
  aspect-ratio: 734 / 746;
  justify-self: center;
  overflow: hidden;
  border-radius: 32px;
  box-shadow: 0 0 0 1px ${colorTokens.loginArtwork.shadowOutline},
    0 4px 8px -2px ${colorTokens.loginArtwork.shadowDepth};

  &::after {
    position: absolute;
    inset: 0;
    content: '';
    background: linear-gradient(
      180deg,
      ${colorTokens.loginArtwork.gradientStart},
      ${colorTokens.loginArtwork.gradientMiddle} 53.365%,
      ${colorTokens.loginArtwork.gradientEnd}
    );
    pointer-events: none;
  }

  @media (max-width: 1034px) {
    display: none;
  }

  @media (min-width: 1035px) {
    background-image: url(${LoginPhoto});
    background-position: left center;
    background-size: cover;
  }
`;
